import { Text, View } from '@react-pdf/renderer';
import { RHeader, RPage, RViewer } from '../../../../components/PdfRender';
import { useCompany } from '../../../../hooks/company';
import * as S from './styles';
import { IReportMovementFinancial } from '../../../interfaces';
import { formatDate } from '../../../utils/format-date';
import { currency } from '../../../utils/functions';

interface IMovementsFinancialsReportProps {
  report: IReportMovementFinancial | null;
}

const MovementsFinancialsReport: React.FC<IMovementsFinancialsReportProps> = ({
  report,
}) => {
  const { company } = useCompany();

  const renderData = () => {
    if (report?.data)
      return (
        <View>
          <View style={S.styles.rowHeader}>
            <Text style={S.styles.columnHeader}>Data Pagamento</Text>
            <Text style={S.styles.columnHeader}>Tipo</Text>
            <Text style={S.styles.columnHeader}>Cliente</Text>
            <Text style={S.styles.columnHeader}>Data Vencimento</Text>
            <Text style={S.styles.columnHeader}>Forma de Pagamento</Text>
            <Text style={[S.styles.columnHeader, { textAlign: 'right' }]}>
              Valor
            </Text>
          </View>
          {report?.data.map((item, index) => (
            <View
              key={item.id}
              style={[
                S.styles.row,
                { backgroundColor: index % 2 === 0 ? '#fff' : '#E3E3E3' },
              ]}
            >
              <Text style={S.styles.column}>
                {formatDate(item.payment_date)}
              </Text>
              <Text style={S.styles.column}>
                {item.type === 0 ? 'Saída' : 'Entrada'}
              </Text>
              <Text style={S.styles.column}>{item.client_name}</Text>
              <Text style={S.styles.column}>{formatDate(item.due_date)}</Text>
              <Text style={S.styles.column}>{item.method_payment}</Text>
              <Text style={[S.styles.column, { textAlign: 'right' }]}>
                {currency(item.value)}
              </Text>
            </View>
          ))}
          <View style={S.styles.rowHeader}>
            <Text style={S.styles.columnHeader}>Saldo</Text>
            <Text style={[S.styles.columnHeader, { textAlign: 'right' }]}>
              {currency(report.totalReceived - report.totalPaid)}
            </Text>
          </View>
        </View>
      );
  };
  return (
    <RViewer>
      <RPage size={'A4'}>
        <RHeader company={company} />
        <View style={S.styles.container}>
          <View style={S.styles.headerTitle}>
            <Text>Movimentação Financeira</Text>
          </View>
        </View>
        {renderData()}
      </RPage>
    </RViewer>
  );
};

export default MovementsFinancialsReport;
